<div fxLayout="column" class="cipo--height--full" data-testid="menu-sidebar">
    <nav
        id="sidebar-menu"
        class="cipo--overflow--hidden"
        [attr.aria-label]="'a11y.layout.mainNavigation' | translate"
        fxLayout="column"
        fxFlex="grow">
        @if (!isCollapsed()) {
            <mat-form-field class="cipo-input search-field" appearance="fill" fxFlex="none">
                <mat-label>{{ "general.searchWaiting" | translate }}</mat-label>
                <input
                    matInput
                    #inputsearch
                    [formControl]="searchControl"
                    id="sidebar-input"
                    data-testid="menu-sidebar-search" />
                @if (searchControl.value) {
                    <button
                        matSuffix
                        mat-icon-button
                        [attr.aria-label]="'a11y.form.clearInput' | translate"
                        (click)="clearSearch()"
                        data-testid="menu-sidebar-search-clear">
                        <mat-icon aria-hidden="true">close</mat-icon>
                    </button>
                }
            </mat-form-field>
        }

        <mat-tree
            [dataSource]="treeData()"
            [childrenAccessor]="childrenAccessor"
            fxFlex="grow"
            class="cipo-bg--primary-50 cipo--overflow-y--auto">
            <mat-tree-node
                fxLayout="row"
                fxLayoutAlign="center center"
                *matTreeNodeDef="let menu"
                matTreeNodePadding
                [matTreeNodePaddingIndent]="isCollapsed() ? 0 : 20"
                class="menu-item cipo-bg--white cipo--cursor--pointer"
                [class.menu-item--active]="menu.id === activeMenuId()"
                [class.menu-item--collapsed]="isCollapsed()"
                (click)="onMenuItemClick(menu)"
                (keydown.enter)="onMenuItemClick(menu)"
                (keydown.space)="$event.preventDefault(); onMenuItemClick(menu)"
                [attr.aria-label]="isCollapsed() ? menu.name : null"
                data-testid="menu-sidebar-tree-node">
                @let isActive = menu.id === activeMenuId();
                <div class="menu-item__inner" [matTooltip]="isCollapsed() ? menu.name : ''" matTooltipPosition="right">
                    @if (isActive) {
                        <div class="menu-item__active-bar"></div>
                    }
                    <itv-module-icon [iconid]="menu.iconId" [color]="menu.color" />
                    @if (!isCollapsed()) {
                        <span class="menu-item__label">{{ menu.name }}</span>
                    }
                </div>
            </mat-tree-node>

            <mat-tree-node
                *matTreeNodeDef="let menu; when: hasChild"
                fxLayout="row"
                fxLayoutAlign="center center"
                [isExpandable]="true"
                matTreeNodePadding
                [matTreeNodePaddingIndent]="isCollapsed() ? 0 : 20"
                class="menu-item menu-item--folder cipo--cursor--pointer"
                [class.menu-item--collapsed]="isCollapsed()"
                [class.menu-item--expanded]="isExpanded(menu)"
                [attr.aria-label]="isCollapsed() ? menu.name : null"
                (click)="onFolderNodeActivate(menu, flyoutTrigger)"
                (keydown.enter)="onFolderNodeActivate(menu, flyoutTrigger)"
                (keydown.space)="$event.preventDefault(); onFolderNodeActivate(menu, flyoutTrigger)"
                data-testid="menu-sidebar-nested-tree-node">
                @if (isCollapsed()) {
                    <div class="menu-item__inner" [matTooltip]="menu.name" matTooltipPosition="right">
                        <itv-module-icon [iconid]="folderIconId(menu)" [color]="menu.color" />
                    </div>
                } @else {
                    <div class="menu-item__inner">
                        <itv-module-icon [iconid]="folderIconId(menu, isExpanded(menu))" [color]="menu.color" />
                        <span class="menu-item__label">{{ menu.name }}</span>
                        <mat-icon
                            class="folder-chevron cipo--text-size--h5 cipo-text--black-400 m-l-auto"
                            [class.folder-chevron--open]="isExpanded(menu)"
                            [style.color]="menu.color"
                            aria-hidden="true">
                            chevron_right
                        </mat-icon>
                    </div>
                }
                <span
                    class="flyout-anchor"
                    aria-hidden="true"
                    appMenuFlyoutFit
                    [matMenuTriggerFor]="isCollapsed() ? folderFlyout.menu() : null"
                    (menuOpened)="folderFlyout.focusActiveItem()"
                    #flyoutTrigger="matMenuTrigger"></span>
                <app-menu-flyout
                    #folderFlyout
                    [items]="menu.children"
                    [label]="menu.name"
                    [iconId]="menu.iconId"
                    [color]="menu.color"
                    [activeId]="activeMenuId()"
                    (itemClick)="onMenuItemClick($event)" />
            </mat-tree-node>
        </mat-tree>
    </nav>
    @if (!isCollapsed()) {
        <app-footer fxFlex="none" data-testid="menu-sidebar-footer" />
    }
</div>
